import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
class Testimonial extends Component{
    render(){
        return(
            <React.Fragment>
                <div className="row">
                    <div className="col-lg-12">
                        <Tabs>
                            <TabPanel>
                                <div className="rn-testimonial-content text-center">
                                    <div className="inner">
                                        <p>Stardust LAB has been a trusted project partner for many years — dependable delivery, clear communication, and consistently strong creative execution.</p>
                                    </div>
                                    <div className="author-info">
                                        <h6><span>Vesna Dedić </span> - Bestselling author</h6>
                                    </div>
                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="rn-testimonial-content text-center">
                                    <div className="inner">
                                        <p>Over the years, we have engaged Stardust LAB on a wide range of projects. They bring structure, speed and accountability, delivering on time and within the agreed budget.</p>
                                    </div>
                                    <div className="author-info">
                                        <h6><span>Dubravka Trišić </span> - Executive editor at Vulkan Publishing</h6>
                                    </div>
                                </div>
                            </TabPanel>
                            <TabPanel>
                                <div className="rn-testimonial-content text-center">
                                    <div className="inner">
                                        <p>We have collaborated with Stardust LAB on multiple projects and have had zero issues with any delivered work. Specifications are respected and handover is always clean.</p>
                                    </div>
                                    <div className="author-info">
                                        <h6><span>JC Pohl </span> - CEO at TEENTRUTH</h6>
                                    </div>
                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="rn-testimonial-content text-center">
                                    <div className="inner">
                                        <p>When professionalism meets deep technical knowledge, results follow. Stardust LAB has supported demanding projects across Greece and the Balkans with discipline and practical expertise.</p>
                                    </div>
                                    <div className="author-info">
                                        <h6><span>Tania Skandalaki </span> - Senior Editor & Publishing Project Manager at DeAgostini SEE</h6>
                                    </div>
                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="rn-testimonial-content text-center">
                                    <div className="inner">
                                        <p>Always a pleasure to work with Stardust LAB. Professional, responsive and pragmatic — you get quick, innovative delivery with minimal friction.</p>
                                    </div>
                                    <div className="author-info">
                                        <h6><span>Bojan Savić </span> - CEO at Češalj & Makaze</h6>
                                    </div>
                                </div>
                            </TabPanel>

                            <TabList className="testimonial-thumb-wrapper">
                                <Tab>
                                    <div className="testimonial-thumbnai">
                                        <div className="thumb">
                                            <img src="/assets/images/client/testimonial-1.jpg" alt="Testimonial Images"/>
                                        </div>
                                    </div>
                                </Tab>
                                <Tab>
                                    <div className="testimonial-thumbnai">
                                        <div className="thumb">
                                            <img src="/assets/images/client/testimonial-2.jpg" alt="Testimonial Images"/>
                                        </div>
                                    </div>
                                </Tab>
                                <Tab>
                                    <div className="testimonial-thumbnai">
                                        <div className="thumb">
                                            <img src="/assets/images/client/testimonial-3.jpg" alt="Testimonial Images"/>
                                        </div>
                                    </div>
                                </Tab>
                                <Tab>
                                    <div className="testimonial-thumbnai">
                                        <div className="thumb">
                                            <img src="/assets/images/client/testimonial-4.jpg" alt="Testimonial Images"/>
                                        </div>
                                    </div>
                                </Tab>
                                <Tab>
                                    <div className="testimonial-thumbnai">
                                        <div className="thumb">
                                            <img src="/assets/images/client/testimonial-5.jpg" alt="Testimonial Images"/>
                                        </div>
                                    </div>
                                </Tab>
                            </TabList>
                        </Tabs>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default Testimonial;
